import { memo, useMemo } from 'react';
import { ColorValue, Text } from 'react-native';
import useGlobalStyles from '../common/style_context';

type Props = {
  name: AppIcons;
  size?: number;
  color?: ColorValue;
};

const AppIcon = memo<Props & { scaled?: boolean }>(({ scaled, ...props }) => {
  if (scaled ?? true) return <AppIconScaled {...props} />;
  return <AppIconNormal {...props} />;
});

const AppIconScaled = memo<Props>(({ name, size: s, color }) => {
  const styles = useMemo(
    () => [
      `icon,fs=${s ?? 24}` + (color !== undefined ? `,c=${String(color)}` : ''),
    ],
    [s, color],
  );
  const [style] = useGlobalStyles(styles);

  return <Text style={style}>{name}</Text>;
});

const AppIconNormal = memo<Props>(({ name, size: s, color }) => {
  const style = useMemo(
    () => ({ fontFamily: 'IPTV-Icons', fontSize: s ?? 24, color }),
    [s, color],
  );

  return <Text style={style}>{name}</Text>;
});

export enum AppIcons {
  home_outline = '\ue908',
  star_outline = '\ue90a',
  tv_outline = '\ue90c',
  bars3_bottom_left = '\ue915',
  bookmark_outline = '\ue91a',
  calendar_days = '\ue926',
  clock = '\ue929',
  arrow_left_circle = '\ue901',
  arrow_right_circle = '\ue902',
  arrow_uturn_left = '\ue903',
  arrows_pointing_in = '\ue904',
  arrows_pointing_out = '\ue905',
  backspace = '\ue900',
  backward = '\ue907',
  bookmark = '\ue909',
  bug = '\ue90b',
  check = '\ue90d',
  check_circle = '\ue90e',
  chevron_down = '\ue90f',
  chevron_left = '\ue910',
  chevron_right = '\ue911',
  chevron_up = '\ue912',
  circle = '\ue92d',
  circle_outlined = '\ue92c',
  exclamation_circle = '\ue916',
  exclamation_circle_outlined = '\ue917',
  exclamation_triangle = '\ue914',
  forward = '\ue918',
  home = '\ue919',
  information_circle = '\ue913',
  magnifying_glass_plus = '\ue91c',
  magnifying_glass_outilne = '\ue91d',
  pause = '\ue91e',
  pause_circle = '\ue91f',
  photo = '\ue920',
  play = '\ue921',
  play_circle = '\ue922',
  rectangle_stack = '\ue923',
  settings = '\ue924',
  star = '\ue925',
  stop_circle = '\ue927',
  tv = '\ue928',
  view_columns = '\ue92a',
  x_mark = '\ue92b',
  funnel_outline = '\ue92e',
  play_circle_outline = '\ue92f',
  settings_outline = '\ue930',
  magnifying_glass = '\ue931',
  ellipsis_horizontal = '\ue932',
  radio_outlined = '\ue933',
  radio = '\ue934',
  user_outlined = '\ue935',
  cells = '\ue936',
  queue_list = '\ue937',
  lock_outlined = '\ue938',
  globe = '\ue939',
  micro = '\ue93a',
  logout_outlined = '\ue91b',
  musical_note = '\ue93b',
  skip_prev = '\ue93c',
  skip_next = '\ue93d',
  delete = '\ue93e',
  question_mark_outlined = '\ue93f',
  speaker = '\ue940',
  sun = '\ue941',
}

export default AppIcon;
